module.exports = __webpack_public_path__ + "img/recruiter.5252d087.svg";